import React from "react";
import { useDispatch } from "react-redux";
import { decreaseCurrentQTY } from "../../../Redux/AddProducts/Actions";
import { addToCart } from "../../../Redux/Cart/Actions";

const Product = ({ product }) => {
    const dispatch = useDispatch();

    const{id,productName, category, img, price, currentQty } = product;

    const handleAddToCart = (id, price) =>{
        dispatch(addToCart(id, price))
        dispatch(decreaseCurrentQTY(id))
    }

  return (
    <>
      <div className="lws-productCard">
        <img
          className="lws-productImage"
          src={img}
          alt="product"
        />
        <div className="p-4 space-y-2">
          <h4 className="lws-productName">{productName}</h4>
          <p className="lws-productCategory">{category}</p>
          <div className="flex items-center justify-between pb-2">
            <p className="productPrice">
              BDT <span className="lws-price">{price}</span>
            </p>
            <p className="productQuantity">
              QTY <span className="lws-quantity">{currentQty}</span>
            </p>
          </div>
          <button 
          disabled={currentQty <= 0 ? true : false}
           onClick={() => handleAddToCart(id, price)} className="lws-btnAddToCart">Add To Cart</button>
        </div>
      </div>
    </>
  );
};

export default Product;
